import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import CobaltTextarea from '@cobalt/react-textarea';

type CobaltTextareaProps = typeof CobaltTextarea extends FunctionComponent<infer P> ? P : never;
interface TextareaProps extends CobaltTextareaProps {
  transparent?: boolean;
}

const TransparentTextarea = styled(CobaltTextarea)`
  transition-property: border, background;

  &:not([disabled]):not([data-co-disabled]):not(&:focus):not([data-co-focus]):not(&:focus-within):not([data-co-focus-within]):not([class*='_co-textarea--error']) {
    border-color: transparent;

    &[data-co-hover],
    &:hover {
      background-color: var(--gray-200);
    }
  }

  &[disabled],
  &[data-co-disabled] {
    border-color: transparent;
    background-color: transparent;
  }
`;

function Textarea(props: TextareaProps) {
  const [t] = useTranslation();

  const { placeholder = t('common.type_here', { defaultValue: 'Type here' }), transparent } = props;

  const TextareaC = !transparent ? CobaltTextarea : TransparentTextarea;

  return <TextareaC data-testid="textarea" {...props} placeholder={placeholder} />;
}

export default Textarea;
